module.exports = __webpack_public_path__ + "05073911834f849510d126c39b5e7e34.svg";